export default defineNuxtPlugin(async (nuxtApp) => {
  try {
    const genericStore = useGenericStore();
    if (genericStore.getCurrencies?.length <= 0) {
      await genericStore.fetchCurrencies();
    }
    await genericStore.fetchGlobalWarning();
  } catch (error) {}
});
